import { AddToCartButton } from '../../../Checkout'
import { ProductCard } from '../../../UiBlocks'

import type { PromoProductCardProps } from '../../types'

const BADGE_CLASSES =
  'absolute left-0 top-0 z-20 bg-gradient-to-r from-orange-400 to-red-700 text-white m-1 p-1 font-medium text-center font-main-font text-xs xl:text-sm leading-3 xl:leading-4'

const OOS_OVERLAY_CLASSES =
  'absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 z-10'

/**
 * PromoProductCard - Wraps UiBlocks ProductCard with promo-specific overlays.
 *
 * Adds:
 * - Discount badge (orange-red gradient, top-left)
 * - Out-of-stock overlay (semi-transparent black)
 * - AddToCartButton only (no wishlist)
 */
export function PromoProductCard({ promoProduct }: PromoProductCardProps) {
  const { product, discountLabel } = promoProduct

  const isOutOfStock = !product.isInStock || product.isNotForSale

  return (
    <div className="relative">
      {/* OOS overlay */}
      {isOutOfStock && (
        <div className={OOS_OVERLAY_CLASSES} role="status" aria-label="Produs epuizat" />
      )}

      {/* Discount badge */}
      <p className={BADGE_CLASSES}>{discountLabel}</p>

      {/* Product card with AddToCartButton action */}
      <ProductCard
        product={product}
        priceSuffix="cu TVA"
        renderActions={(p) => <AddToCartButton sku={p.sku} />}
      />
    </div>
  )
}
